import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Label3 } from "../../Labels";
var UserRowDeactivated = function (_a) {
    var isEnabled = _a.isEnabled;
    if (isEnabled) {
        return null;
    }
    return (React.createElement(Label3, null,
        React.createElement(FormattedMessage, { id: "platform.userSearch.deactivated" })));
};
export default UserRowDeactivated;
